import React from 'react';
import styled from '@emotion/styled';
import {colors} from '@atlaskit/theme';
import {Droppable, Draggable} from 'react-beautiful-dnd';

import WordItem from './WordItem';
import {grid} from '../constants';
import Title from './Title';

export const getBackgroundColor = (isDraggingOver, isDraggingFrom) => {
  if (isDraggingOver) {
    return colors.R50;
  }
  if (isDraggingFrom) {
    return colors.T50;
  }
  return colors.N30;
};

const Wrapper = styled.div`
  background-color: ${(props) => getBackgroundColor(props.isDraggingOver, props.isDraggingFrom)};
  display: flex;
  flex-direction: column;
  opacity: ${({isDropDisabled}) => (isDropDisabled ? 0.5 : 'inherit')};
  padding: ${grid}px;
  border: ${grid}px;
  padding-bottom: 0;
  transition: background-color 0.2s ease, opacity 0.1s ease;
  user-select: none;
  /* width: 200px; */ /* REMOVED a specific width */

  /* ADDED box shadow */
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24);
`;

const scrollContainerHeight = 250;

const DropZone = styled.div`
  /* stop the list collapsing when empty */
  min-height: ${scrollContainerHeight}px;

  /*
    not relying on the items for a margin-bottom
    as it will collapse when the list is empty
  */
  padding-bottom: ${grid}px;
`;

const ScrollContainer = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  /*max-height: ${scrollContainerHeight}px;*/
  /*max-height: calc(100vh - 120px);*/
  max-height: calc(100vh - 220px);
`;

const Container = styled.div``;

const InnerWordList = React.memo(function InnerWordList(props) {
  return props.words.map((word, index) => (
    <Draggable key={word.uuid} draggableId={word.uuid} index={index}>
      {(dragProvided, dragSnapshot) => (
        <WordItem
          key={word.uuid}
          word={word}
          isDragging={dragSnapshot.isDragging}
          provided={dragProvided}
          index={index}
          handleClickDeleteWord={props.handleClickDeleteWord}
          isEditable={props.isEditable}
        />
      )}
    </Draggable>
  ));
});

function InnerList(props) {
  const {words, dropProvided, handleClickDeleteWord, isEditable} = props;
  const title = props.title ? <Title>{props.title}</Title> : null;

  return (
    <Container>
      {title}
      <DropZone ref={dropProvided.innerRef}>
        <InnerWordList words={words} handleClickDeleteWord={handleClickDeleteWord} isEditable={isEditable} />
        {dropProvided.placeholder}
      </DropZone>
    </Container>
  );
}

export default function WordList(props) {
  const {
    ignoreContainerClipping,
    internalScroll,
    scrollContainerStyle,
    isDropDisabled,
    listId = 'LIST',
    listType,
    style,
    words,
    title,
    handleClickDeleteWord,
    isEditable,
  } = props;

  return (
    <Droppable
      droppableId={listId}
      type={listType}
      ignoreContainerClipping={ignoreContainerClipping}
      isDropDisabled={isDropDisabled}
    >
      {(dropProvided, dropSnapshot) => (
        <Wrapper
          style={style}
          isDraggingOver={dropSnapshot.isDraggingOver}
          isDropDisabled={isDropDisabled}
          isDraggingFrom={Boolean(dropSnapshot.draggingFromThisWith)}
          {...dropProvided.droppableProps}
        >
          {internalScroll ? (
            <ScrollContainer style={scrollContainerStyle}>
              <InnerList
                words={words}
                title={title}
                dropProvided={dropProvided}
                handleClickDeleteWord={handleClickDeleteWord}
                isEditable={isEditable}
              />
            </ScrollContainer>
          ) : (
            <InnerList
              words={words}
              title={title}
              dropProvided={dropProvided}
              handleClickDeleteWord={handleClickDeleteWord}
              isEditable={isEditable}
            />
          )}
        </Wrapper>
      )}
    </Droppable>
  );
}
